import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services'
import QUERY from 'lodash'
import formatter from '../formatter'

export default {
  data () {
    return {
      fetching: {
        taxCodes: false
      },
      options: {
        taxCodes: []
      },
      selected: {
        taxCode: ''
      },
      editable: {
        taxCode: ''
      }
    }
  },

  methods: {

    async getTaxCodes (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.taxCode
      const fetching = context.fetching?.taxCodes
      const options = context.options?.taxCodes

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.taxCodes = true
      context.selected.taxCode = ''

      const filters = formatter.methods.objectToUrl({
        filter_text: search
      })

      return await SSharedList.getTaxCodes(filters).then(
        ({ data }) => {
          context.options.taxCodes = data
        }
      ).catch(() => {
        context.options.taxCodes = []
      }).finally(() => {
        context.fetching.taxCodes = false
      })
    },

    async searchTaxCodes (search, loading) {
      this.searchTaxCodesProvider(this, search, loading)
    },

    searchTaxCodesProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.taxCodes, {
          keys: ['tax_name']
        })

        if (filteredOptions.length <= 1) {
          loading(true)

          const filters = formatter.methods.objectToUrl({
            filter_text: search
          })

          SSharedList.getTaxCodes(filters).then(
            ({ data }) => {
              options.taxCodes = data
            }
          ).catch(() => {
            options.taxCodes = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
